var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGeo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m19.953 3.284-1.511.559L0 10.669l8.798 3.77 3.774 8.803 7.381-19.958Zm-2.518 2.518L12.47 19.221 9.93 13.306l-5.918-2.542 13.422-4.962Z",
  fill: "#1A1A1A"
})));
export default SvgGeo;